import {Directive} from '@angular/core';
import {FormControl, NG_VALIDATORS} from '@angular/forms';
import {checkIfASCII, checkIfGiveCharIsNumberOrLetter, checkIfValidHostName, normalizeString} from '../util/CommonFunctions';


export function hostNameValidator(control: FormControl) {
  let host = control.value;

  if(host == null || host.trim() === ""){
    return null;
  }

  if (!checkIfASCII(host)) {
    return {
      invalidHostName: "Invalid Host, Host name cannot contain non-ASCII characters"
    }
  }

  host = normalizeString(host);

  if (!checkIfValidHostName(host)) {
    return {
      invalidHostName: "Invalid Host Name"
    }
  }

  if (host.length > 254) {
    return {
      invalidHostName: "Invalid Host Name, Host name is too long"
    }

  }

  const pieces: Array<string> = host.split(".");
  for (let piece of pieces) {
    if (piece.length > 63)
      return {
        invalidHostName: "Invalid Host Name, Host name is too long"
      }
    if (piece.length == 0)
      return {
        invalidHostName: "Invalid Host Name"
      }
    if (!checkIfGiveCharIsNumberOrLetter(piece.charAt(0)))
      return {
        invalidHostName: "Invalid Host name, first letter can be either letter or digit"
      }
    if (!checkIfGiveCharIsNumberOrLetter(piece.charAt(piece.length - 1)))
      return {
        invalidHostName: "Invalid Host name, first letter can be either letter or digit"
      }
  }
  return null;
}

@Directive({
  selector: '[hostNameValidator][ngModel]',
  providers: [
    {provide: NG_VALIDATORS, useValue: hostNameValidator, multi: true}
  ]
})
export class HostNameValidatorDirective {

  constructor() { }

}
